import { createTheme } from '@mui/material/styles';

export const standaloneTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#020202',
      paper: '#000'
    },
    text: {
      primary: '#ffffff',
      secondary: '#cfcfcf'
    }
  }
});
